import { useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import GroupRatings from "../ratings/GroupRatings";
import HomeroomRatings from "../ratings/HomeroomRatings";

/**
 * BatchStudentRatings — thin mode router.
 *
 * Derives the current mode from the URL and delegates to the appropriate
 * route-level component. No state, no data fetching, no logic.
 *
 * Routes:
 *   …/input-ratings/groups* → GroupRatings
 *   everything else          → HomeroomRatings
 */
const BatchStudentRatings = ({ dispatch, state, basePath, teacherGuid }) => {
    const { pathname } = useLocation();
    const isGroups = useMemo(() => pathname?.includes("groups"), [pathname]);

    if (isGroups) {
        return <GroupRatings dispatch={dispatch} state={state} basePath={basePath} teacherGuid={teacherGuid} />;
    }

    return <HomeroomRatings dispatch={dispatch} state={state} basePath={basePath} />;
};

BatchStudentRatings.propTypes = {
    basePath: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    state: PropTypes.shape({
        gradingProfiles: PropTypes.array,
        navCollapsed: PropTypes.bool,
        selectedEpr: PropTypes.object
    }).isRequired,
    teacherGuid: PropTypes.string
};

export default BatchStudentRatings;
